<template>
  <div>
    <v-card v-if="notFound" flat>
      <v-card-text>
        <v-card-text>
          <div class="text-center title">This link is expire.</div>
        </v-card-text>
      </v-card-text>
    </v-card>

    <div v-else>
      <v-card class="mx-auto" flat max-width="600" v-if="!cardCollected">

        <div class="text-center mt-4" v-if="Info">
          <img v-if="Info && Info.Business && Info.Business.imageUrl" height="50" :src="Info.Business.imageUrl"
            alt="Logo" />

          <div class="text-h5">{{ Info.Business.name }}</div>
          <div>{{ Info.Business.phoneNumber }}</div>
        </div>


        <div outlined class="mt-5">
          <v-card-text>
            <v-row>

              <v-col cols="12">
                <v-text-field outlined :error-messages="nameErrors" :hide-details="nameErrors.length === 0" dense
                  autofocus v-model="EventData.name" label="Full Name"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field outlined @change="fixEmail" :error-messages="emailErrors"
                  :hide-details="emailErrors.length === 0" dense v-model="EventData.email"
                  label="Email Address"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field outlined @change="fixEmail" :error-messages="phoneNumberErrors"
                  :hide-details="phoneNumberErrors.length === 0" dense v-model="EventData.phoneNumber"
                  label="Phone Number"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field outlined dense :background-color="`${EventData.dob ? false : '#E8F5E9'}`"
                  @change="validateAge" :error-messages="dobError" :hide-details="dobError.length === 0" type="date"
                  v-model="EventData.dob" label="Date of Birth"></v-text-field>

                <p v-if="errorMessage" class="error px-2">{{ errorMessage }}</p>
              </v-col>
            </v-row>

            <v-col cols="12" class="py-2">
              <div class="mb-2 text-center">{{ EventData.amount | currency }} Payment Due on Submit</div>
              <div class="text-center">How you like to pay?</div>
            </v-col>

            <CreditCard v-if="Info" :hideBank="true" @submit="paymentCollected" :autofocus="false" :localCollectOnly="true"
              :donationCategoryId="Info.Business.DefaultSchoolFeeId" :customer="Info" :public="true" />


          </v-card-text>



          <v-card-actions>
            <v-btn @click="submit" :loading="loading" :disabled="loading" color="primary" width="150" block large>Submit</v-btn>
          </v-card-actions>


        </div>


        <v-card-actions>
          <div class="text-right">
            Power by: <span>taleem.app</span> -
            <span class="caption">{{ version }}</span>
          </div>
        </v-card-actions>
      </v-card>

      <v-card v-else flat>
        <div class="text-center mt-4" v-if="Info">
          <img v-if="Info.Business.imageUrl" height="50" :src="Info.Business.imageUrl" alt="Logo" />

          <div class="text-h5">{{ Info.Business.name }}</div>
          <div>{{ Info.Business.phoneNumber }}</div>
        </div>
        <v-card-text>
          <lottie :height="200" :options="defaultOptions" name="receiptCheck" v-on:animCreated="handleAnimation"
            @onComplete="done" />
          <div v-if="showValue" class="text-center">
            <div class="text-h5">All Set</div>
            <!-- <div class="mt-3">
                O Allah send prayers upon the family of [ the giver of charity ]
                <span class="font-weight-bold">Bukhari Hadith - 1497</span>
              </div> -->
          </div>
        </v-card-text>
      </v-card>
    </div>


  </div>
</template>
<!-- <script src="https://js.stripe.com/v3/"></script> -->
<script>
import eventService from "@/modules/Events/service.js";
// import CreditCard from "@/modules/Donors/PaymentInfoCollect/CreditCard.vue";
// import { Card, createToken } from "vue-stripe-elements-plus";
import Lottie from "@/components/lottie.vue";
import * as animationData from "@/assets/lottie/1708-success.json";
const pjson = require("../../../../package.json");
const { validationMixin } = require("vuelidate");
const { required, email } = require("vuelidate/lib/validators");

// import applicationService from "@/modules/Application/service.js";
// import paymentMethodService from "@/modules/PaymentMethod/service.js";

import CreditCard from '@/modules/PaymentMethod/components/CreditCard.vue'

export default {
  name: "card-collect",
  data() {
    return {
      EventDataId: null,
      EventData: {
        name: null,
        email: null,
        dob: null,
        phoneNumber: null,
        amount: 0
      },
      age: null,       // The calculated age
      errorMessage: '',
      goodToGood: false,
      loading: false,
      notFound: false,
      showValue: false,
      cardCollected: false,
      Info: null,
      complete: false,
      stripe: null,
      defaultOptions: {
        animationData: animationData.default,
        loop: false,
        autoplay: true,
      },
    };
  },
  components: {
    CreditCard,
    Lottie,
  },
  created() {
    this.loadData();
  },
  mixins: [validationMixin],
  validations: {
    EventData: {
      name: {
        required,
      },
      email: {
        required,
        email,
      },
      phoneNumber: {
        required,
      },
      dob: {
        required,
      },
    }
  },
  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.EventData.email.$dirty) return errors;
      if (!this.$v.EventData.email.required) errors.push("Email address is required");
      if (!this.$v.EventData.email.email) errors.push("Email is not valid");
      return errors;
    },
    phoneNumberErrors() {
      const errors = [];
      if (!this.$v.EventData.phoneNumber.$dirty) return errors;
      if (!this.$v.EventData.phoneNumber.required)
        errors.push("Phone Number is required");
      return errors;
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.EventData.name.$dirty) return errors;
      if (!this.$v.EventData.name.required) errors.push("Name is required");
      return errors;
    },
    dobError() {
      const errors = [];
      if (!this.$v.EventData.dob.$dirty) return errors;
      if (!this.$v.EventData.dob.required)
        errors.push("Date of birth is required");
      return errors;
    },
    version() {
      return pjson.version;
    },
  },
  methods: {
    validateAge() {
      if (!this.EventData.dob) {
        this.errorMessage = 'Please enter your date of birth.';
        this.age = null;
        return;
      }

      const today = new Date();
      const dob = new Date(this.EventData.dob);
      const diff = today - dob;
      const age = Math.floor(diff / (1000 * 60 * 60 * 24 * 365.25)); // Calculate age

      this.age = age;

      // Validate age
      if (age < 13) {
        this.errorMessage = `Your age is ${age}. You must be at least 13 years old.`;
        this.goodToGood = false;
      } else if (age > 18) {
        this.errorMessage = `Your age is ${age}. You must be under 18 years old.`;
        this.goodToGood = false;
      } else {
        this.goodToGood = true;
        this.errorMessage = ''; // Clear error if valid
      }
    },
    fixEmail() {
      this.EventData.email = this.EventData.email.toLowerCase().trim();
    },
    done() {
      this.showValue = true;
    },
    paymentCollected(event) {
      this.EventData.payment = event
      this.EventData.business = this.Info.Business
      this.EventData.EventDataId = this.EventDataId

      console.log('EventData', this.EventData)
      eventService.applyEvent(this.EventData).then((response) => {
        console.log('apply for event', response)
        this.cardCollected = true;
        // this.reset()
        // this.$emit('submit')

      }).catch(error => {
        this.loading = false;
        console.log("error adding card2", error);
        // this.$swal("Payment!", error.data.message, "error");
      })
      // this.cardCollected = true;
    },
    submit() {
      console.log('goodToGood', this.goodToGood)
      this.$v.$touch();
      this.validateAge()
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });

      } else {
        if (!this.goodToGood) {
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "error",
              title: this.$t("toastMessage.text.invalidFields"),
            });
        } else {
          this.loading = true
          this.$events.emit("submitCreditCard");
        }
      }
    },
    handleAnimation(anim) {
      this.anim = anim;
    },


    loadData() {
      let id = this.$route.params.id;

      return eventService
        .getPublicEventById(id)
        .then((response) => {
          console.log("response new", id, response);
          if (response.data) {
            this.Info = response.data;
            this.EventDataId = this.Info.id
            this.EventData.amount = this.Info.amount
            // this.StripeKey = this.Info.Business.metadata.publicStripeId;
            // this.cardCollected = this.Info.isCollected;
            document.title = this.Info.Business.name;
          } else {
            // console.log("asdkfjaslkdfjlaksjdf;lkasjdf");
            this.notFound = true;
          }

          // this.Donor = response.data;
          // console.log('response.data.alert', response)
          // if (response.data && !response.data.alert) response.data.alert = false
          this.$Progress.finish();
        })
        .catch(() => {
          this.loading = false
          this.$Progress.finish();
        });
    },
  },
};
</script>

<style scoped>
.error {
  color: white;
}
</style>